import script from "./Empty.vue?vue&type=script&lang=ts&setup=true"
export * from "./Empty.vue?vue&type=script&lang=ts&setup=true"

import "./Empty.vue?vue&type=style&index=0&id=d0e0b1e0&lang=css"

export default script